import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined'
import AutoGraphOutlined from '@mui/icons-material/AutoGraphOutlined'
import BlockOutlined from '@mui/icons-material/BlockOutlined'
import RequestPageOutlined from '@mui/icons-material/RequestPageOutlined'
import { CardContent } from '@mui/material'
import { useNavigate } from 'react-router'
import { CardButton, Grid, Box, Breadcrumbs } from '../../components'
import { PageHeader } from '../../layout'
import { Link } from 'react-router-dom'

export const ReportsPage = () => {
  const navigation = useNavigate()
  return (
    <div>
      <PageHeader>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '.5rem',
            fontSize: '22px',
            fontWeight: 800,
            height: 40
          }}
        >
          Relatórios
        </Box>
        <Box sx={{ marginBottom: '30px' }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/home" color="#262626" style={{ color: '#595959' }}>
              Início
            </Link>
            <span style={{ color: '#595959' }}>Relatórios</span>
          </Breadcrumbs>
        </Box>
      </PageHeader>
      <Grid container spacing={0.5}>
        <Grid item xs={6} sm={4} md={4} lg={2.4} xl={2.4}>
          <CardButton width="90%">
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: '80px', md: '150px', lg: '130px' }
              }}
              onClick={() => {
                navigation('/reports/commissions')
              }}
            >
              <AttachMoneyOutlined color="primary" />
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  paddingLeft: 5
                }}
              >
                Comissões
              </div>
            </CardContent>
          </CardButton>
        </Grid>
        <Grid item xs={6} sm={4} md={4} lg={2.4} xl={2.4}>
          <CardButton width="90%">
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: '80px', md: '150px', lg: '130px' }
              }}
              onClick={() => {
                navigation('/reports/abc/clients')
              }}
            >
              <AutoGraphOutlined color="primary" />
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  paddingLeft: 5
                }}
              >
                Curva ABC de Clientes
              </div>
            </CardContent>
          </CardButton>
        </Grid>
        <Grid item xs={6} sm={4} md={4} lg={2.4} xl={2.4}>
          <CardButton width="90%">
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: '80px', md: '150px', lg: '130px' }
              }}
              onClick={() => {
                navigation('/reports/abc/products')
              }}
            >
              <RequestPageOutlined color="primary" />
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  paddingLeft: 5
                }}
              >
                Curva ABC de Produtos
              </div>
            </CardContent>
          </CardButton>
        </Grid>
        <Grid item xs={6} sm={4} md={4} lg={2.4} xl={2.4}>
          <CardButton width="90%">
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: '80px', md: '150px', lg: '130px' }
              }}
              onClick={() => {
                navigation('/reports/debts')
              }}
            >
              <BlockOutlined color="primary" />
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  paddingLeft: 5
                }}
              >
                Inadimplências
              </div>
            </CardContent>
          </CardButton>
        </Grid>
        <Grid item xs={6} sm={4} md={4} lg={2.4} xl={2.4}>
          <CardButton width="90%">
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: '80px', md: '150px', lg: '130px' }
              }}
              onClick={() => {
                navigation('/reports/orders')
              }}
            >
              <RequestPageOutlined color="primary" />
              <div
                style={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  paddingLeft: 5
                }}
              >
                Pedidos
              </div>
            </CardContent>
          </CardButton>
        </Grid>
      </Grid>
    </div>
  )
}

export default ReportsPage
